<template>
  <CardGraphicWithBorder
    img-alt="Changement d'utilisateur"
    img-src="/images/family/switch-member.svg"
    :show-controls="true"
    :close-click-outside="true"
  >
    <template #title> Accompagnez ses révisions </template>
    <template #description>
      <p>
        <strong>{{ displayName }}</strong> peut réviser depuis votre compte.
        Abonnez-vous à Nomad+ pour activer cette fonctionnalité.
      </p>
    </template>
    <template #footer>
      <ButtonBase
        theme="secondary"
        stroke="n"
        class="button"
        :disabled="false"
        rounded
        size="small"
        :to="urlPremium"
      >
        M'abonner
      </ButtonBase>
    </template>
  </CardGraphicWithBorder>
</template>
<script setup lang="ts">
interface Props {
  member: FamilyMember;
}
const props = defineProps({
  member: null
});

const { displayName } = useFamilyMember(toRef(() => props.member));

const { urlDialogFamilySubscribe: urlPremium } = useUrlPremium();
</script>
<style lang="scss" scoped>
.card {
  justify-self: center;
}
</style>
